import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ace4cb52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "living" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "living_title" }, "展示样式", -1))
const _hoisted_3 = { class: "living_type" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "living_content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "living_content_title" }, "内容设置", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "living_content_tip" }, "添加直播：默认显示前两个最新的直播，可上下拖拽直播间", -1))
const _hoisted_8 = { class: "living_content_setup" }
const _hoisted_9 = { class: "setup_title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "模块标题", -1))
const _hoisted_11 = { class: "setup_input_length" }
const _hoisted_12 = { class: "setup_title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "最多显示", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 直播间可以无限添加，最多显示的设置只显示在H5页面展示的数量，最多设置5个展示位，超过5个直播间H5展示更多按钮（设置2-3个展示位，添加四个直播间可显示更多按钮，同理设置2-3个展示位直播间只添加2-3个不会显示更多按钮） ", -1))

import { ref } from 'vue';
import emitter from '@/utils/mitt';
import { QuestionCircleFilled } from '@ant-design/icons-vue';
import { InputNumber, Tooltip } from 'ant-design-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Living_setup',
  props: {
  custom: {},
  labelId: {},
},
  setup(__props) {

const props: any = __props;

const aInputNumber = InputNumber;
const aTooltip = Tooltip;


const living = ref();
living.value =
  props.custom.type == 6 || props.custom.type == 7
    ? { ...props.custom.tabsList[props.labelId].nestedList[0] }
    : { ...props.custom };

const getType = (index: number) => {
  living.value.style = index;
  living.value.liveList.map((res: any) => {
    res.style = index;
  });
  toVisualization();
};

const toVisualization = () => {
  if (props.custom.type == 6 || props.custom.type == 7) {
    const custom = { ...props.custom };
    custom.tabsList[props.labelId].nestedList[0] = { ...living.value };
    emitter.emit('visualization', custom);
  } else {
    emitter.emit('visualization', living.value);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
        return _createElementVNode("div", {
          key: item,
          class: _normalizeClass([living.value.style == index ? 'type_btn_click' : '', "type_btn"]),
          onClick: ($event: any) => (getType(index))
        }, [
          _createVNode(_component_svg_icon, {
            "icon-class": index == 0 ? 'myLive_type' : index == 1 ? 'myLive_type_one' : 'myLive_type_two'
          }, null, 8, ["icon-class"])
        ], 10, _hoisted_4)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_a_input, {
            class: "setup_input",
            placeholder: "请输入主标题",
            maxlength: 6,
            value: living.value.title,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((living.value.title) = $event)),
            onChange: toVisualization
          }, {
            suffix: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, _toDisplayString(living.value.title.length) + "/ 6", 1)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_unref(aInputNumber), {
            value: living.value.most,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((living.value.most) = $event)),
            onChange: toVisualization,
            class: "setup_title_number",
            min: 1,
            max: 5
          }, null, 8, ["value"]),
          _createVNode(_unref(aTooltip), { placement: "left" }, {
            title: _withCtx(() => [
              _hoisted_14
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(QuestionCircleFilled), { class: "setup_title_icon" })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})